module.exports = __webpack_public_path__ + "img/sent.4464fc23.svg";